import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { S11MemoType } from 'src/app/modules/s11-e-signature/shared/pre-approve-models';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-location-denied',
  templateUrl: './location-denied.component.html',
  styleUrls: ['./location-denied.component.scss'],
})
export class LocationDeniedComponent implements OnInit, OnDestroy {
  token: string;
  memoType: S11MemoType;
  memoId: number;
  fromPath = false;
  fromMemo = false;
  private readonly destroy$ = new Subject<void>();
  private locationCheckInterval: ReturnType<typeof setInterval>;

  constructor(private route: ActivatedRoute, private router: Router) {
    if (window.history.state && 'fromPath' in window.history.state) {
      this.fromPath = !!window.history.state.fromPath;
    }
    if (window.history.state && 'fromMemo' in window.history.state) {
      this.fromMemo = !!window.history.state.fromMemo;
    }
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('jwtToken') || '';
    if (
      !this.fromPath &&
      window.history.state &&
      'fromPath' in window.history.state
    ) {
      this.fromPath = !!window.history.state.fromPath;
    }

    this.isBase64Json(this.token);
    if (!this.fromPath) {
      this.goBack();
    } else {
      this.startLocationPermissionCheck();
    }
  }

  isBase64Json(str: string): void {
    try {
      const decoded = JSON.parse(
        atob(str.replace(/-/g, '+').replace(/_/g, '/')),
      );
      if (!decoded) return;
      this.memoType = decoded.memo_type;
      this.memoId = decoded.memo_id;
    } catch {
      console.error('Invalid JWT');
    }
  }

  goBack(toMemo = false) {
    if (this.memoId && this.memoType && !this.fromMemo) {
      this.router.navigate(['s11-documents', 'preview', this.token]);
    } else if (toMemo) {
      this.router.navigate(
        ['pending-approval', this.memoId, 'listofapproval'],
        {
          queryParams: { memoType: this.memoType },
        },
      );
    } else {
      this.router.navigate(['pending-approval']);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.locationCheckInterval) {
      clearInterval(this.locationCheckInterval);
    }
  }

  private startLocationPermissionCheck(): void {
    this.checkLocationPermission();
    this.locationCheckInterval = setInterval(() => {
      this.checkLocationPermission();
    }, 2000);
  }

  private checkLocationPermission(): void {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((permissionStatus) => {
          if (permissionStatus.state === 'granted') {
            if (this.locationCheckInterval) {
              clearInterval(this.locationCheckInterval);
            }
            this.goBack(true);
          }

          permissionStatus.addEventListener('change', () => {
            if (permissionStatus.state === 'granted') {
              if (this.locationCheckInterval) {
                clearInterval(this.locationCheckInterval);
              }
              this.goBack(true);
            }
          });
        });
    }
  }
}
